import { RootState } from 'types'
import { Action } from 'redux/actions'
import { SidebarActions } from 'redux/actions/sidebar'
import { SIDEBAR_WIDTH_KEY } from 'redux/constants'

export default function reduce(state: RootState['sidebarWidth'] = 256, action: Action): RootState['sidebarWidth'] {
  switch (action.type) {
    case SidebarActions.SET_SIDEBAR_WIDTH: {
      localStorage.setItem(SIDEBAR_WIDTH_KEY, action.payload.toString())
      return action.payload
    }

    default:
      return state
  }
}
